import { useState } from 'react';
import { Modal } from '@atoms/Modal';
import { Button } from '@atoms/Button';
import { useQuantityPickerStore } from '@store/uiStore';
import { useCartStore } from '@store/cartStore';
import { formatCurrency } from '@utils/formatters';
import { getErrorMessage } from '@services/api';

const QUICK_AMOUNTS = [1, 2, 5, 10];

export function QuantityModal() {
  const { product, closeQuantityPicker } = useQuantityPickerStore();
  const addItem = useCartStore((s) => s.addItem);
  const [quantity, setQuantity] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const open = Boolean(product);

  const handleClose = () => {
    setQuantity(1);
    setError(null);
    closeQuantityPicker();
  };

  const handleConfirm = async () => {
    if (!product) return;
    setLoading(true);
    setError(null);
    try {
      await addItem(product.id, quantity);
      handleClose();
    } catch (err) {
      setError(getErrorMessage(err, 'Sepete eklenemedi'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={handleClose} title={product?.name ?? 'Miktar Seç'}>
      {product && (
        <div className="space-y-4">
          {product.image && (
            <img src={product.image} alt={product.name} className="mx-auto h-32 rounded-lg object-cover" />
          )}
          <p className="text-center text-lg font-bold text-brand-600">
            {formatCurrency(Number(product.price))} / {product.unit}
          </p>

          <div className="flex justify-center gap-2">
            {QUICK_AMOUNTS.map((n) => (
              <button
                key={n}
                type="button"
                onClick={() => setQuantity(n)}
                className={`rounded-lg px-4 py-2 text-sm font-medium ${
                  quantity === n ? 'bg-brand-500 text-white' : 'bg-gray-100 text-gray-700'
                }`}
              >
                {n}
              </button>
            ))}
          </div>

          <div className="flex items-center justify-center gap-3">
            <button
              type="button"
              className="rounded-lg border px-3 py-1 text-lg"
              onClick={() => setQuantity((q) => Math.max(1, q - 1))}
            >
              −
            </button>
            <span className="min-w-[3rem] text-center text-xl font-bold">{quantity}</span>
            <button
              type="button"
              className="rounded-lg border px-3 py-1 text-lg"
              onClick={() => setQuantity((q) => q + 1)}
            >
              +
            </button>
          </div>

          {error && <p className="text-center text-sm text-red-600">{error}</p>}

          <Button fullWidth loading={loading} onClick={handleConfirm}>
            Sepete Ekle ({quantity})
          </Button>
        </div>
      )}
    </Modal>
  );
}
